import {useContext, useMemo} from 'react';

import {ErrorMessage} from 'formik';
import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {MultiSelectV2} from '../../../../../../../../../components/MultiSelectV2/MultiSelectV2';
import {LanguageContext} from '../../../../../../../../../contexts/LanguageContext/LanguageContext';
import {Option} from '../../../../../../../../../types/shared-types';
import {safelyUseLanguageProfile} from '../../../../../../../../../utils/safelyUseLanguageProfile';
import {Department} from '../../../../../types/JobPostingsTypes';

interface HardFactsFieldsDepartmentProps {
  formik: any;
  options: Department[];
}

export const HardFactsFieldsDepartment = ({options, formik}: HardFactsFieldsDepartmentProps) => {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  const onChange = (values: Option[]) => {
    formik.setFieldValue(
      'departments',
      values.map((opt) => opt.id)
    );
  };

  const departmentOptions = useMemo(() => {
    return options.map((option) => {
      return {
        id: option.resourceId,
        label: safelyUseLanguageProfile(currentLanguage, option.name) || '',
        selected: (formik?.values?.departments || []).some((id: string) => id === option.resourceId),
      };
    });
  }, [options, currentLanguage, formik?.values?.departments]);

  return (
    <Grid item xs={12}>
      <MultiSelectV2
        label={`${t('companyJobPostings.newJobDialog.formLabels.department')}`}
        options={departmentOptions}
        onChangeHandler={onChange}
        size='small'
      />
      <Typography variant='body2' color='error'>
        <ErrorMessage name='departments' component='span' />
      </Typography>
    </Grid>
  );
};
